import { Box, Button, Typography } from "@mui/material";
import React from "react";
import walletcoveredbg from "../../../../media/images/walletcoverdbg.svg";
import BottomTabbar from "../../../layout/DriverLayout/BottomTabbar";
import LogoSe from "../../../../media/images/icons/logoSecondary.svg";
import DashboardHeader from "./Header";
import MenuDashboard from "./MenuDashboard";
import MainContent from "./MainContent";
import BannerBox from "./Banner";
import Activities from "./Activities";

export default function DashboardPage() {
  return (
    <>
      <Box
        sx={{
          flex: 1,
          border: "1px solid gray",
          overflow: "auto",
        }}
      >
        <Box
          sx={{
            position: "relative",
            backgroundImage: `
         url(${walletcoveredbg})
         `,
            height: "180px",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundColor: "#0D4884",
            paddingX: "8px",
            paddingTop: "16px",
          }}
        >
          <DashboardHeader />
          <MenuDashboard />
        </Box>
        <Box
          sx={{
            paddingX: "8px",
            display: "flex",
            flexDirection: "column",
            gap: "8px",
            paddingBottom: "16px",
          }}
        >
          <MainContent />
          <BannerBox />
          <Activities />
        </Box>
      </Box>
      <BottomTabbar />
    </>
  );
}
